const f = {
  color: {
    active: {
      tint: "#b9edbdff",
      core: "#2d8556ff"
    },
    pending: {
      tint: "#9ecbffff",
      core: "#304ddbff"
    },
    closed: {
      tint: "#dfe6ebff",
      core: "#556575ff"
    },
    spam: {
      tint: "#ffbcadff",
      core: "#b83525ff"
    }
  }
};
export {
  f as convoStatusSymbol
};
